import { COURSES_MODULE_LOCKED_MESSAGE } from '@sportspredict/shared';

/** Readable message of an RTK Query error (or anything thrown). */
export function getCoursesErrorMessage(error: unknown): string {
	if (!error) return 'Something went wrong';
	if (error instanceof Error) return error.message;
	if (typeof error === 'object') {
		const e = error as { data?: { message?: unknown }; error?: unknown; status?: unknown };
		if (typeof e.data?.message === 'string') return e.data.message;
		if (typeof e.error === 'string') return e.error;
		if (e.status === 'FETCH_ERROR') return 'Network error';
	}
	return 'Something went wrong';
}

export function isCoursesNotFoundError(error: unknown): boolean {
	return typeof error === 'object' && error !== null && 'status' in error && error.status === 404;
}

export function isCoursesConflictError(error: unknown): boolean {
	return typeof error === 'object' && error !== null && 'status' in error && error.status === 409;
}

export function isCoursesForbiddenError(error: unknown): boolean {
	return typeof error === 'object' && error !== null && 'status' in error && error.status === 403;
}

/** The API refused because the lesson's module is locked, not the whole course. */
export function isModuleLockedError(error: unknown): boolean {
	return (
		isCoursesForbiddenError(error) &&
		getCoursesErrorMessage(error) === COURSES_MODULE_LOCKED_MESSAGE
	);
}

/**
 * `invalidatesTags` for an idempotent DELETE: a 404 means the record is already gone, so the
 * cache is refreshed exactly as after a success; any other failure leaves it alone.
 */
export function invalidatesAfterDelete<T extends string>(tags: readonly T[]) {
	return (_result: unknown, error: unknown): T[] =>
		!error || isCoursesNotFoundError(error) ? [...tags] : [];
}
